import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'
import index from '@/view/yeMast/yeMast.vue'
import video from '@/view/video/video.vue'
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/video',
      name: 'video',
      component: video
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js